import { CheckCircle2, Lock, X } from 'lucide-react';
import { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { evaluarPassword, SCORE_MINIMO } from '../../lib/passwordStrength';
import PasswordStrength from './PasswordStrength';
import PasswordField from './PasswordField';

export default function CambiarPasswordModal({ onClose }) {
  const [nueva, setNueva]       = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);
  const [exito, setExito]       = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(null);

    if (nueva.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      return;
    }
    const ev = evaluarPassword(nueva);
    if (ev.score < SCORE_MINIMO) {
      setError('Esta contraseña es muy débil. Sigue las sugerencias debajo del campo para mejorarla.');
      return;
    }
    if (nueva !== confirmar) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password: nueva });
    setLoading(false);

    if (err) {
      setError(err.message || 'No se pudo cambiar la contraseña.');
      return;
    }
    setExito(true);
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 9999, padding: 20,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--bg-card)', borderRadius: 12, padding: 24,
          width: '100%', maxWidth: 400, border: '0.5px solid var(--border-200)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: 'var(--text-strong)' }}>
            <Lock size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /> Cambiar contraseña
          </h2>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--ink-400)' }}
          >
            <X size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} />
          </button>
        </div>

        {exito ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}><CheckCircle2 size={16} strokeWidth={1.75} aria-hidden style={{verticalAlign:"-3px",display:"inline-block"}} /></div>
            <p style={{ color: 'var(--text-strong)', marginBottom: 16 }}>
              Contraseña actualizada
            </p>
            <p style={{ fontSize: 12, color: 'var(--ink-400)', marginBottom: 20 }}>
              La próxima vez que entres usa la contraseña nueva.
            </p>
            <button
              onClick={onClose}
              style={{
                padding: '10px 20px', background: 'var(--accent)', color: 'white',
                border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontFamily: 'inherit',
              }}
            >
              Listo
            </button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)', marginBottom: 5 }}>
                Nueva contraseña
              </label>
              <PasswordField
                value={nueva}
                onChange={e => setNueva(e.target.value)}
                autoFocus
                placeholder="mínimo 8 caracteres"
                inputStyle={{
                  width: '100%', padding: '9px 11px', border: '0.5px solid var(--border-200)',
                  borderRadius: 6, background: 'var(--bg-app)', color: 'var(--text-strong)',
                  fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box',
                }}
              />
              <PasswordStrength password={nueva} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, color: 'var(--ink-500)', marginBottom: 5 }}>
                Confirmar contraseña
              </label>
              <PasswordField
                value={confirmar}
                onChange={e => setConfirmar(e.target.value)}
                placeholder="repite la contraseña"
                inputStyle={{
                  width: '100%', padding: '9px 11px', border: '0.5px solid var(--border-200)',
                  borderRadius: 6, background: 'var(--bg-app)', color: 'var(--text-strong)',
                  fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box',
                }}
              />
            </div>
            {error && (
              <div style={{
                padding: '8px 12px', background: 'var(--sev-critico-bg)', color: 'var(--sev-critico)',
                borderRadius: 6, fontSize: 12, marginBottom: 12,
              }}>
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '10px', background: 'var(--accent)', color: 'white',
                border: 'none', borderRadius: 6, cursor: loading ? 'wait' : 'pointer',
                fontSize: 14, fontFamily: 'inherit', opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Guardando…' : 'Cambiar contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
